import NFTLabs from 'contract/Labs.json';
import {useContract} from "Standard/hooks/useCommonContracts";
import {getMMProLabsContract} from "utils/getAddress";

export const useNFTLabsContract = () => {
  const abi = NFTLabs.abi;
  return useContract(abi, getMMProLabsContract());
}